<template lang="pug">
li.py-3
  span.text-black-50.small {{ formatDate(item.created) }}
  a {{ item.title }}
  span.text-black-50.small(style="margin-right: 12px")
    font-awesome-icon.mr-1(:icon="['fas', 'eye']") 
    | {{ item.view_count }}
  span.text-black-50.small
    font-awesome-icon.mr-1(:icon="['fas', 'share-alt']") 
    | {{ item.share_count }}
</template>

<script>
import moment from "moment";

export default {
  name: "MostItem",
  props: {
    item: Object,
  },
  methods: {
    formatDate(date) {
      return moment(date).format("MMM,DD,YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  border-bottom: 1px rgba(0, 0, 0, 0.2) dashed !important;
}

li:last-child {
  border-bottom: none !important;
}

a {
  display: block;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

@media only screen and (max-width: 959px) {
  .jumbotron .display-4 {
    font-size: 2rem;
  }
}
</style>
